export const getOptionInterval = (dateFrom, dateTo, optionDeadlines) => {
    const interval = parseInt((dateTo.getTime() - dateFrom.getTime()) / 1000);
    return getMatchOptionInterval(interval, optionDeadlines);
}

export const getMatchOptionInterval = (interval, optionDeadlines) => {
    const filteredDeadlines = optionDeadlines.filter(deadline => deadline.value <= interval);
    return filteredDeadlines.length ? filteredDeadlines[0].value : optionDeadlines[filteredDeadlines.length - 1].value;
}

export const getInterval = (dateFrom, dateTo) => {
    return parseInt((dateTo.getTime() - dateFrom.getTime()) / 1000);
}

export const getDateRange = interval => {
    const dateFrom = new Date();
    const dateTo = new Date();

    dateTo.setSeconds(parseInt(interval) + dateTo.getSeconds());

    return {
        dateFrom: dateFrom,
        dateTo: dateTo,
    };
}